import type {Extension, Handle} from 'mdast-util-from-markdown'

/** Adds `isBlock` property to block HTML nodes. */
export function mdastEnrichHtml(): Extension {
  return {
    exit: {
      htmlFlow: enrichHtmlFlowNode,
    },
  }
}

declare module 'mdast' {
  interface HtmlData {
    /** Indicates whether this is block HTML rather than inline HTML. */
    isBlock?: true
  }
}

const enrichHtmlFlowNode: Handle = function (this) {
  // The last node on the stack will be a `Fragment`, so find the nearest `Html` parent
  const node = this.stack.findLast(n => n.type === 'html')
  if (node?.type === 'html') {
    node.data ??= {}
    // all htmlFlow tokens are block HTML
    node.data.isBlock = true
  }
  return false
}
